// React
import React, {Component} from "react";
import {connect} from "react-redux";
// Routing
import {withRouter} from "react-router-dom";
// Material
import {CircularProgress} from "@material-ui/core";
// Vendor
import {showNotify} from "vendor/application/disptach";
// Infrastructure
import {IntegrationsAPI} from "api/application/Integrations";
// Application
import {VerneFields} from "./form";
import {addPendingPhrase, isVerneComplete, updateVerneData, updateVernePhrases} from "./utils";
// Translations
import {withTranslation} from "react-i18next";
// Components
import {Button} from "@components/Input";
import DialogAction from "components/Dialog/DialogAction";
// SVG
import {channelsSvg} from "assets";
import {arrowRightSvg} from "@assets";

class Edit extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: "",
            set_key_words: "",
            set_entry_phrases: "",
            open: false
        };
    }

    componentDidMount = () => {
        this.getIntegration();
    };

    getIntegration = async () => {
        const {access, actualProject} = this.props.data;
        try {
            let obj = new IntegrationsAPI(actualProject.id, access, this.props);
            let integration = await obj.get_integration_by_id();

            this.setState({data: integration});
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
            this.return();
        }
    };

    updateElement = (e, type) => {
        this.setState({data: updateVerneData(this.state.data, e, type)});
    };

    handleKeyWords = (e, type, elementType, chipToDelete, i) => {
        const pending = `set_${elementType}`;
        const new_state = updateVernePhrases(this.state.data, this.state[pending], e, type, chipToDelete, i, elementType);
        if (new_state) {
            this.setState({data: new_state.data, [pending]: new_state.value});
        }
    };

    return = () => {
        const {history} = this.props;
        const {actualProject} = this.props.data;
        history.push(`/${actualProject.id}/integrations`);
    };

    putIntegration = async (e) => {
        e.preventDefault();
        const {access, actualProject} = this.props.data;
        let data = addPendingPhrase(this.state.data, this.state.set_entry_phrases, "entry_phrases");
        data = addPendingPhrase(data, this.state.set_key_words, "key_words");
        this.setState({data: data, set_key_words: "", set_entry_phrases: ""});

        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props, data);
            await obj.put_integration();

            this.props.dispatch(showNotify({message: "integrations", type: "edit", severity: "success"}));
            await this.getIntegration();
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    handleClickOpen = () => {
        this.setState({open: !this.state.open});
    };

    handleDelete = async () => {
        const {access, actualProject} = this.props.data;
        try {
            const obj = new IntegrationsAPI(actualProject.id, access, this.props);
            await obj.delete_integration(this.state.data.id);

            this.props.dispatch(showNotify({message: "integrations", type: "delete", severity: "success"}));

            this.handleClickOpen();
            this.return();
        } catch (err) {
            this.props.dispatch(showNotify({message: err, severity: "error"}));
        }
    };

    render() {
        const {data, set_key_words, set_entry_phrases, open} = this.state;
        const {t} = this.props;
        const {isSending, actualLayout} = this.props.data;
        return (
            <React.Fragment>
                <div className={"cen_integrations"}>
                    <div className={"header"}>
                        <div className={"header_content"}>
                            <div onClick={() => this.return()} className={"header_action"}>
                                {arrowRightSvg()}
                            </div>
                            <div className={"header_image"}>
                                {channelsSvg("verne")}
                            </div>
                            <div className={"header_title"}>
                                <span className={"title"}>{t("integrations:channels.verne.title")}</span>
                                <span className={"description"}>{t("integrations:categories.business")}</span>
                            </div>
                        </div>
                        <div className={"header_actions"}>
                            {
                                isSending ? (
                                    <Button type={"primary"} disabled text={<CircularProgress size={21}/>}/>
                                ) : (
                                    <Button type={"primary"}
                                            text={t("integrations:save.action_button")}
                                            disabled={!isVerneComplete(data, set_entry_phrases, set_key_words)}
                                            onClick={(e) => this.putIntegration(e)}/>
                                )
                            }
                        </div>
                    </div>
                    {
                        data
                            ? <VerneFields
                                t={t}
                                data={data}
                                set_key_words={set_key_words}
                                set_entry_phrases={set_entry_phrases}
                                updateElement={this.updateElement}
                                handleKeyWords={this.handleKeyWords}
                            />
                            : <div className={"content"}>
                                <div className="loading">
                                    <CircularProgress color="primary" size={50}/>
                                </div>
                            </div>
                    }
                </div>
                {
                    data &&
                    <div className={"cen_integrations delete"}>
                        <div className={"integration"}>
                            <div className={"integration_info"}>
                                <span
                                    className={"integration_info_title"}>{t("integrations:channels.verne.delete.title")}</span>
                                <span
                                    className={"integration_info_description"}>{t("integrations:channels.verne.delete.description")}</span>
                            </div>
                            <Button type={"normal_delete"}
                                    text={t("integrations:channels.verne.delete.action_button")}
                                    onClick={() => this.setState({open: true})}/>
                        </div>
                    </div>
                }
                <DialogAction t={t} actualLayout={actualLayout.layout} handleAction={this.handleDelete}
                              handleClickOpen={this.handleClickOpen} common open={open} item={{name: ""}}/>
            </React.Fragment>
        );
    }
}


const mapStateToProps = state => {
    return {
        data: state
    };
};

const edit = connect(
    mapStateToProps
)(Edit);

export default withTranslation(["commons", "integrations", "common"])(withRouter(edit));
